export default "__VITE_ASSET__c06a1c6c__"